<template>
  <!--数据统计-->
  <div class="statistics info-con">
    <div class="statisticstop">
      <ul class="topTitle">
        <li
          v-for="(list, index) in listData"
          :key="index"
          @click="changeTitle(index)"
          :class="{ active: index == isIndex }"
        >
          {{ list.name }}
        </li>
        <li :class="{ active: isIndex == 4 }">自定义</li>
      </ul>
      <div class="block" style="margin: 0 30px; position: relative">
        <div v-show="timeShow" id="list" class="timeTip">
          {{ selectAry.startDate }}-{{ selectAry.endDate }}
        </div>
        <el-date-picker
          :picker-options="pickerOptions"
          @focus="focusTime"
          @blur="blurTime"
          :editable="false"
          :clearable="false"
          v-model="time"
          type="daterange"
          size="small"
          range-separator=""
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="timeChange"
          style="padding: 0; padding-left: 10px"
        >
        </el-date-picker>
        <img
          class="label6"
          style="
            position: absolute;
            left: 90px;
            top: 50%;
            transform: translateY(-50%);
            width: 11.5px;
            margin-left: 11px;
            margin-right: 9px;
          "
          referrerpolicy="no-referrer"
          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngdffe0be40ee1328e2b8bb578fc704a30928a2da596ada5e6fafa17e1a3912a7b"
        />
        <!-- <i
          class="el-icon-date"
          style="
            position: absolute;
            right: 13px;
            top: 50%;
            transform: translateY(-50%);
          "
          referrerpolicy="no-referrer"
        /> -->
      </div>
      <div style="color: #3b3946; font-size: 14px">
        数据更新截止到今日00:00前
      </div>
      <el-button
        class="export"
        @click="exportAll"
        type="primary"
        icon="iconfont icon-daochu"
      >
        <!-- <i class="iconfont icon-daochu" style="font-size: 18px"></i> -->
        <span>导出更多</span>
      </el-button>
    </div>
    <div class="statistics-content" style="display: flex; flex-wrap: wrap">
      <div class="mc-title">
        <h4>版权数据</h4>
        <div class="mctitle">
          <StatisticsHeader title="版权图片用量" num="1"></StatisticsHeader>
          <div class="mc_bottom">
            <div class="mc_progress" style="width: 80%">
              <div style="width: 100%">
                <ul
                  class="mc_ul"
                  style="margin-top: 29px; margin-bottom: 3px; width: 100%"
                >
                  <li class="li1">{{ statisticsUserNumData.used }}</li>
                  <li class="li1" style="margin-left: auto">
                    {{ statisticsUserNumData.total }}
                  </li>
                </ul>
                <el-progress
                  :percentage="percentage"
                  :color="customColor"
                  :show-text="false"
                  style="width: 100%"
                >
                </el-progress>
                <ul class="mc_ul" style="margin-top: 2px; width: 100%">
                  <li class="li2">已用量(张)</li>
                  <li class="li2" style="margin-left: auto">套餐总量(张)</li>
                </ul>
              </div>
              <!-- <ul style="margin-top: 29px; margin-left: 80px">
                <li class="li1">{{ statisticsUserNumData.averageUsage }}</li>
                <li class="li2 mt">日均用量(张)</li>
              </ul> -->
            </div>
          </div>
        </div>
        <div class="mc-con">
          <StatisticsHeader title="版权图片使用数据" num="2"></StatisticsHeader>
          <el-table
            :data="userList"
            v-if="userList && userList.length"
            height="520"
            style="margin: 0 24px"
            width="100%"
            :header-cell-style="{ background: '#F7F6F9' }"
          >
            <el-table-column label="排序" width="100">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              prop="team_style_id"
              label="图片ID"
              width="150"
            ></el-table-column>
            <el-table-column label="图片" width="100">
              <template slot-scope="scope">
                <el-popover
                  placement="right"
                  trigger="hover"
                  popper-class="popover"
                >
                  <div class="popimg">
                    <img
                      :src="scope.row.img"
                      alt=""
                      class="imgcon"
                    />
                  </div>
                  <div
                    slot="reference"
                    style="
                      width: 36px;
                      height: 36px;
                      background: #f7f6f9;
                      border-radius: 4px;
                    "
                  >
                    <img
                      :src="scope.row.img"
                      alt=""
                      class="imgcon"
                    />
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              prop="used_times"
              label="使用次数"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="image_source"
              label="图片来源"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="nick_name"
              label="加入人"
              min-width="150"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="created_at"
              label="加入时间"
              width="200"
            ></el-table-column>
          </el-table>
          <no-content
            v-if="!userList"
            :text="'暂无数据'"
            :url="url"
            :bgUrlShow="bgUrlShow"
          />
        </div>
      </div>
      <div class="mc-title">
        <h4>成员数据</h4>
        <div class="mctitle">
          <StatisticsHeader
            title="成员情况"
            num="3"
            content="展示企业中可以容纳的人数、使用人数和成员活跃情况"
          ></StatisticsHeader>
          <div class="mc_bottom">
            <div class="mc_progress">
              <div style="width: 68%">
                <ul
                  class="mc_ul"
                  style="margin-top: 29px; margin-bottom: 3px; width: 100%"
                >
                  <li class="li1">{{ dataList.use_member }}</li>
                  <li class="li1" style="margin-left: auto">
                    {{ dataList.members }}
                  </li>
                </ul>
                <el-progress
                  :percentage="percentage1"
                  :color="customColor"
                  style="width: 100%"
                  :show-text="false"
                >
                </el-progress>
                <ul class="mc_ul" style="margin-top: 2px; width: 100%">
                  <li class="li2">加入成员(人)</li>
                  <li class="li2" style="margin-left: auto">总量(人)</li>
                </ul>
              </div>
              <ul style="margin-top: 29px; margin-left: 70px">
                <li class="li1">{{ dataList.yesterday_active }}</li>
                <li class="li2 mt">昨日活跃(人)</li>
              </ul>
              <!-- <ul style="margin-top: 29px; margin-left: auto">
                <li class="li1">{{ dataList.average_active }}</li>
                <li class="li2 mt">日均活跃(人)</li>
              </ul> -->
            </div>
          </div>
        </div>
        <div class="mc-con">
          <StatisticsHeader title="成员作品数据" num="4"></StatisticsHeader>
          <el-table
            :data="designData"
            v-if="designData && designData.length"
            height="520"
            style="margin: 0 24px"
            :header-cell-style="{ background: '#F7F6F9' }"
          >
            <el-table-column label="排序" width="100">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              prop="user.nick_name"
              label="成员名"
              width="150"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="create_num"
              label="创建模版"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="team_num"
              label="设为企业模版"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="down_num"
              label="下载模版"
              width="150"
            ></el-table-column>
            <el-table-column label="下载样式预览" width="300">
              <template slot-scope="scope">
                <div style="display: flex; align-items: center" class="allimg">
                  <el-popover
                    v-for="(img, index) in scope.row.down_design"
                    :key="index"
                    placement="right"
                    trigger="hover"
                    popper-class="popover"
                  >
                    <div class="popimg" v-if="index < 3">
                      <img
                        :src="issafariBrowser ? img.img : img.thumbnail_img"
                        alt=""
                        class="imgcon"
                      />
                    </div>
                    <div
                      v-if="index < 3"
                      slot="reference"
                      style="
                        width: 36px;
                        height: 36px;
                        background: #f7f6f9;
                        border-radius: 4px;
                      "
                    >
                      <img
                        :src="issafariBrowser ? img.img : img.thumbnail_img"
                        alt=""
                        class="imgcon"
                      />
                    </div>
                  </el-popover>
                  <div
                    v-if="scope.row.down_design.length"
                    @click="gotoTemp(scope.row.user.id, 1)"
                    style="font-size: 14px; color: #5a2df5; cursor: pointer"
                  >
                    全部
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <no-content
            v-if="!designData"
            :text="'暂无数据'"
            :url="url"
            :bgUrlShow="bgUrlShow"
          />
        </div>
      </div>
      <div class="mc-title">
        <h4>资产数据</h4>
        <div class="mctitle">
          <StatisticsHeader
            title="企业空间作品"
            num="5"
            content="企业模版的总数、昨日新增"
          ></StatisticsHeader>
          <div class="mc_bottom">
            <div class="mc_progress">
              <ul style="margin-top: 29px">
                <li class="li1">{{ enterpriseData.all_num }}</li>
                <li class="li2">总数(个)</li>
              </ul>
              <ul style="margin-top: 29px; margin-left: 144px">
                <li class="li1">{{ enterpriseData.yesterday_num }}</li>
                <li class="li2">昨日新增(个)</li>
              </ul>
              <!-- <ul style="margin-top: 29px; margin-left: auto">
                <li class="li1">{{ enterpriseData.average_num }}</li>
                <li class="li2">日均新增数(个)</li>
              </ul> -->
            </div>
          </div>
        </div>
        <div class="mctitle">
          <StatisticsHeader
            title="个人空间作品"
            num="6"
            content="我的空间中模板的总数、昨日新增"
          ></StatisticsHeader>
          <div class="mc_bottom">
            <div class="mc_progress">
              <ul style="margin-top: 29px">
                <li class="li1">{{ personalData.all_num }}</li>
                <li class="li2">总数(个)</li>
              </ul>
              <ul style="margin-top: 29px; margin-left: 144px">
                <li class="li1">{{ personalData.yesterday_num }}</li>
                <li class="li2">昨日新增(个)</li>
              </ul>
              <!-- <ul style="margin-top: 29px; margin-left: auto">
                <li class="li1">{{ personalData.average_num }}</li>
                <li class="li2">日均新增数(个)</li>
              </ul> -->
            </div>
          </div>
        </div>
        <div class="mc-con">
          <StatisticsHeader title="作品下载数据" num="7"></StatisticsHeader>
          <el-table
            :data="downloadData"
            v-if="downloadData && downloadData.length"
            height="520"
            style="margin: 0 24px"
            :header-cell-style="{ background: '#F7F6F9' }"
          >
            <el-table-column label="模版预览" width="100">
              <template slot-scope="scope">
                <el-popover
                  placement="right"
                  trigger="hover"
                  popper-class="popover"
                  v-if="scope.row.template"
                >
                  <div class="popimg">
                    <img
                      :src="
                        issafariBrowser
                          ? scope.row.template.cover_url
                          : scope.row.template.thumbnail_cover_url
                      "
                      alt=""
                      class="imgcon"
                    />
                  </div>
                  <div
                    slot="reference"
                    style="
                      width: 36px;
                      height: 36px;
                      background: #f7f6f9;
                      border-radius: 4px;
                    "
                  >
                    <img
                      :src="
                        issafariBrowser
                          ? scope.row.template.cover_url
                          : scope.row.template.thumbnail_cover_url
                      "
                      alt=""
                      class="imgcon"
                    />
                  </div>
                </el-popover>
                <p v-else>已删除</p>
              </template>
            </el-table-column>
            <!-- <el-table-column label="模版ID" width="150">
              <template slot-scope="scope">
                <p v-if="scope.row.template">{{ scope.row.template.id }}</p>
              </template>
            </el-table-column> -->
            <el-table-column
              prop="nick_name"
              label="模版创建人"
              width="150"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="down_num"
              label="下载次数"
              width="150"
            ></el-table-column>
            <el-table-column label="下载样式预览" width="300">
              <template slot-scope="scope">
                <div style="display: flex; align-items: center" class="allimg">
                  <el-popover
                    v-for="(img, index) in scope.row.download"
                    :key="index"
                    placement="right"
                    trigger="hover"
                    popper-class="popover"
                  >
                    <div class="popimg" v-if="index < 3">
                      <img
                        :src="issafariBrowser ? img.thumbnail_img : img.thumbnail_webp_img"
                        alt=""
                        class="imgcon"
                      />
                    </div>
                    <div
                      v-if="index < 3"
                      slot="reference"
                      style="
                        width: 36px;
                        height: 36px;
                        background: #f7f6f9;
                        border-radius: 4px;
                      "
                    >
                      <img
                        :src="issafariBrowser ? img.thumbnail_img : img.thumbnail_webp_img"
                        alt=""
                        class="imgcon"
                      />
                    </div>
                  </el-popover>
                  <div
                    v-if="scope.row.download && scope.row.download.length && scope.row.template"
                    @click="gotoTemp(scope.row.template.id, 2)"
                    style="font-size: 14px; color: #5a2df5; cursor: pointer"
                  >
                    全部
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <no-content
            v-if="!downloadData"
            :text="'暂无数据'"
            :url="url"
            :bgUrlShow="bgUrlShow"
          />
        </div>
      </div>
      <div
        class="mc-title"
        style="position: relative; height: 666px; min-height: 666px"
      >
        <h4>活跃账号数据</h4>
        <div
          class="mctitle"
          style="
            border-bottom-left-radius: initial;
            border-bottom-right-radius: initial;
          "
        >
          <StatisticsHeader title="活跃账号数" num="8"></StatisticsHeader>
        </div>
        <div class="left chartLine">
          <p class="p1 chartLinep"></p>
          <p class="p2" style="color: #3b3946; font-size: 14px">活跃账号数</p>
        </div>
        <div
          id="chartLineBox"
          style="
            width: 100%;
            height: 535px;
            padding-top: 64px;
            background: #fff;
            border-bottom-left-radius: 4px;
            border-bottom-right-radius: 4px;
          "
        ></div>
      </div>
    </div>
    <Dialog :list="list" :slot="slot" :bgUrlShow="bgUrlShow" :url="url">
    </Dialog>
    <!--过期弹出框-->
    <expireTeamDialog />
  </div>
</template>

<script>
import * as echarts from "echarts";
import { Statistics } from "@/config/axios/new_api";
import noContent from "@/components/common/noContent.vue";
import Dialog from "./components/dialog.vue";
import StatisticsHeader from "./components/statisticsHeader.vue";
export default {
  components: {
    noContent,
    Dialog,
    StatisticsHeader,
  },
  data() {
    return {
      slot: "statisticsDialog1",
      Pagination: {
        total: 0,
        page: 1,
        page_size: 10,
      },
      dialogTableVisible: false,
      timeShow: false,
      url: require("@/assets/image/nocontent.png"),
      bgUrlShow: 0,
      percentage: 0,
      percentage1: 0,
      customColor: "#5A2DF5",
      time: "",
      selectAry: {
        startDate: "", // 开始时间
        endDate: "", // 结束时间
      },
      startTime: "",
      endTime: "",
      listData: [
        {
          name: "昨天",
        },
        {
          name: "近7天",
        },
        {
          name: "近30天",
        },
        {
          name: "近90天",
        },
      ],
      isIndex: 1,
      loading: "",
      dataLoading: false,
      pickerOptions: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          let three = 360 * 24 * 3600 * 1000;
          let threeMonths = curDate - three;
          return (
            time.getTime() > Date.now() - 8.64e7 || time.getTime() < threeMonths
          );
        },
      },
      list: [],
      arrTime: [],
      newArr: [], //折线图数据
      userList: [], //版权图片使用数据列表
      dataList: [],
      enterpriseData: [],
      personalData: [],
      designData: [],
      downloadData: [],
      statisticsUserNumData: [], //版权图片用量数据---总量数据---日均用量返回
      activeList: [],
      aq: true,
      page: 1,
      page_size: 10,
      num: 0,
      load: false, //开关避免点击刷新多次
      min: "",
      max: "",
      issafariBrowser: "",
      loadShow: true,
      loadinga: false,
    };
  },
  computed: {
    loginInfo() {
      return this.$store.getters.loginInfo;
    },
  },
  mounted() {
    document.getElementsByClassName("el-range__close-icon")[0].className +=
      " el-icon-date data-prefixer";
    this.issafariBrowser =
      /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    this.firstTime(7);
    this.statistics_use_num();
    this.statistics_data();
    this.statistics_enterprise_data();
    this.statistics_personal_design_data();
  },
  methods: {
    // 跳转到瀑布流
    gotoTemp(userid, num) {
      let routes = this.$router.resolve({
        name: "ImageList",
        query: {
          team_id: this.loginInfo.current_team_id,
          userid: userid,
          page: 1,
          num: num,
          startTime: this.startTime,
          endTime: this.endTime,
        },
      });
      window.open(routes.href, "_blank");
    },
    handleCurrentChange(val = 1) {
      this.Pagination.page = val;
      if (this.num == 4) {
        this.statistics_design_data_list();
      }
      if (this.num == 7) {
        this.statistics_enterprise_design_download_data_list();
      }
    },
    // 日期选择器得到焦点
    focusTime() {
      this.timeShow = true;
    },
    // 日期选择器失去焦点
    blurTime() {
      this.timeShow = false;
    },
    // 初始化echarts
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById("chartLineBox"));
      setTimeout(function () {
        window.onresize = function () {
          myChart.resize();
        };
      }, 200);
      // 绘制图表
      var option;

      var data = this.newArr;

      var dateList = data.map(function (item) {
        return item[0];
      });
      var valueList = data.map(function (item) {
        return item[1];
      });

      option = {
        // Make gradient line here
        tooltip: {
          trigger: "axis",
        },
        xAxis: [
          {
            data: dateList,
            axisLine: {
              lineStyle: {
                color: "#F2F0F6",
              },
            },
            axisLabel: {
              textStyle: {
                //改变xy轴上文字的颜色
                color: "#3B3946",
              },
            },
          },
        ],
        yAxis: [
          {
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                color: "#F2F0F6",
              },
            },
          },
        ],
        grid: [
          {
            bottom: "20%",
          },
          {
            top: "20%",
          },
        ],
        series: [
          {
            type: "line",
            showSymbol: false,
            data: valueList,
            itemStyle: {
              normal: {
                color: "#5A2DF5",
                lineStyle: {
                  color: "#5A2DF5",
                },
              },
            },
          },
        ],
      };
      option && myChart.setOption(option);
    },
    // 默认时间
    firstTime(num) {
      this.time = [
        new Date().getTime() - 3600 * 1000 * 24 * num,
        new Date().getTime() - 3600 * 1000 * 24,
      ];
      this.selectAry.startDate = this.getLocalTime(this.time[0], 1);
      this.selectAry.endDate = this.getLocalTime(this.time[1], 1);
      this.startTime = this.getLocalTime(this.time[0], 0);
      this.endTime = this.getLocalTime(this.time[1], 0);
      this.statistics_use_num();
      this.statistics_data();
      this.statistics_enterprise_data();
      this.statistics_personal_design_data();
      this.statistics_use_list();
      this.statistics_design_data();
      this.statistics_enterprise_design_download_data();
      this.statistics_active();
    },
    // 时间戳转换
    getLocalTime(originVal, num) {
      const dt = new Date(originVal);
      const y = dt.getFullYear();
      const m = (dt.getMonth() + 1 + "").padStart(2, "0");
      const d = (dt.getDate() + "").padStart(2, "0");
      const hh = (dt.getHours() + "").padStart(2, "0");
      const mm = (dt.getMinutes() + "").padStart(2, "0");
      const ss = (dt.getSeconds() + "").padStart(2, "0");
      if (num == 1) {
        return y + "/" + m + "/" + d;
      } else if (num == 2) {
        return y + m + d + hh + mm + ss;
      } else {
        return y + "-" + m + "-" + d;
      }
    },
    // 时间格式处理
    datetimeparse(timestamp, format, prefix) {
      if (typeof timestamp == "string") {
        timestamp = Number(timestamp);
      }
      //转换时区
      let currentZoneTime = new Date(timestamp);
      let currentTimestamp = currentZoneTime.getTime();
      let offsetZone = currentZoneTime.getTimezoneOffset() / 60; //如果offsetZone>0是西区，西区晚
      let offset = null;
      //客户端时间与服务器时间保持一致，固定北京时间东八区。
      offset = offsetZone + 8;
      currentTimestamp = currentTimestamp + offset * 3600 * 1000;

      let newtimestamp = null;
      if (currentTimestamp) {
        if (currentTimestamp.toString().length === 13) {
          newtimestamp = currentTimestamp.toString();
        } else if (currentTimestamp.toString().length === 10) {
          newtimestamp = currentTimestamp + "000";
        } else {
          newtimestamp = null;
        }
      } else {
        newtimestamp = null;
      }
      let dateobj = newtimestamp
        ? new Date(parseInt(newtimestamp))
        : new Date();
      let YYYY = dateobj.getFullYear();
      let MM =
        dateobj.getMonth() > 8
          ? dateobj.getMonth() + 1
          : "0" + (dateobj.getMonth() + 1);
      let DD =
        dateobj.getDate() > 9 ? dateobj.getDate() : "0" + dateobj.getDate();
      let HH =
        dateobj.getHours() > 9 ? dateobj.getHours() : "0" + dateobj.getHours();
      let mm =
        dateobj.getMinutes() > 9
          ? dateobj.getMinutes()
          : "0" + dateobj.getMinutes();
      let ss =
        dateobj.getSeconds() > 9
          ? dateobj.getSeconds()
          : "0" + dateobj.getSeconds();
      let output = "";
      let separator = "/";
      if (format) {
        separator = format.match(/-/) ? "-" : "/";
        output += format.match(/yy/i) ? YYYY : "";
        output += format.match(/MM/)
          ? (output.length ? separator : "") + MM
          : "";
        output += format.match(/dd/i)
          ? (output.length ? separator : "") + DD
          : "";
        output += format.match(/hh/i) ? (output.length ? " " : "") + HH : "";
        output += format.match(/mm/) ? (output.length ? ":" : "") + mm : "";
        output += format.match(/ss/i) ? (output.length ? ":" : "") + ss : "";
      } else {
        output += YYYY + separator + MM + separator + DD;
      }
      output = prefix ? prefix + output : output;

      return newtimestamp ? output : "";
    },
    timeChange(val) {
      this.startTime = this.datetimeparse(val[0], "YY-MM-DD");
      this.endTime = this.datetimeparse(val[1], "YY-MM-DD");
      this.isIndex = 4;
      this.statistics_use_num();
      this.statistics_data();
      this.statistics_enterprise_data();
      this.statistics_personal_design_data();
      this.statistics_use_list();
      this.statistics_design_data();
      this.statistics_enterprise_design_download_data();
      this.statistics_active();
    },
    changeTitle(index) {
      this.isIndex = index;
      if (index == 0) {
        this.firstTime(1);
      }
      if (index == 1) {
        this.firstTime(7);
      }
      if (index == 2) {
        this.firstTime(30);
      }
      if (index == 3) {
        this.firstTime(90);
      }
    },
    // 更多弹出框
    morePop(num) {
      this.num = num;
      this.list = [];
      this.page = 1;
      this.aq = true;
      this.dialogTableVisible = true;
      this.slot = "statisticsDialog" + num;
      if (num == 1) {
        this.statistics_use_num_details();
      }
      if (num == 2) {
        this.statistics_use_details();
      }
      if (num == 3) {
        this.statistics_detail_list();
      }
      if (num == 4) {
        this.statistics_design_data_list();
      }
      if (num == 5) {
        this.statistics_enterprise_design_detail_list();
      }
      if (num == 6) {
        this.statistics_personal_design_detail_list();
      }
      if (num == 7) {
        this.statistics_enterprise_design_download_data_list();
      }
      if (num == 8) {
        this.statistics_active_details();
      }
    },
    exportAll(e) {
      this.buttonBlur(e);
      this.statistics_use_num_details_export();
      this.statistics_use_list_export();
      this.statistics_detail_export();
      this.statistics_design_data_export();
      this.statistics_enterprise_design_detail_export();
      this.statistics_personal_design_download_data_export();
      this.statistics_enterprise_design_download_data_export();
      this.statistics_active_details_export();
    },
    // 页面导出非弹窗导出
    exportList(num) {
      if (num == 1) {
        this.statistics_use_num_details_export();
      }
      if (num == 2) {
        this.statistics_use_list_export();
      }
      if (num == 3) {
        this.statistics_detail_export();
      }
      if (num == 4) {
        this.statistics_design_data_export();
      }
      if (num == 5) {
        this.statistics_enterprise_design_detail_export();
      }
      if (num == 6) {
        this.statistics_personal_design_download_data_export();
      }
      if (num == 7) {
        this.statistics_enterprise_design_download_data_export();
      }
      if (num == 8) {
        this.statistics_active_details_export();
      }
    },
    loadMore() {
      if (this.aq == false) {
        return;
      }
      if (this.page == 1 || this.page == 0) {
        this.page++;
      }
      if (this.num == 1) {
        this.statistics_use_num_details();
      }
      if (this.num == 2) {
        this.statistics_use_details();
      }
      if (this.num == 3) {
        this.statistics_detail_list();
      }
      if (this.num == 4) {
        this.statistics_design_data_list()
      }
      if (this.num == 5) {
        this.statistics_enterprise_design_detail_list();
      }
      if (this.num == 6) {
        this.statistics_personal_design_detail_list();
      }
      // if(this.num==7){
      //   this.statistics_enterprise_design_download_data_list()
      // }
      if (this.num == 8) {
        this.statistics_active_details();
      }
    },
    // 版权图片用量数据---总量数据---日均用量返回
    statistics_use_num() {
      var data = {
        team_id: this.loginInfo.current_team_id,
        start_time: this.startTime,
        end_time: this.endTime,
      };
      Statistics.statistics_use_num(data).then((res) => {
        if (res.status == 1) {
          this.statisticsUserNumData = res.data;
          this.percentage = (res.data.used / res.data.total) * 100;
        }
      });
    },
    // 成员情况
    statistics_data() {
      var data = {
        team_id: this.loginInfo.current_team_id,
        start_time: this.startTime,
        end_time: this.endTime,
      };
      Statistics.statistics_member_ship_data(data).then((res) => {
        if (res.status == 1) {
          this.dataList = res.data;
          this.percentage1 = (res.data.use_member / res.data.members) * 100;
        }
      });
    },
    // 企业空间作品
    statistics_enterprise_data() {
      var data = {
        team_id: this.loginInfo.current_team_id,
        start_date: this.startTime,
        end_date: this.endTime,
      };
      Statistics.statistics_enterprise_data(data).then((res) => {
        if (res.status == 1) {
          this.enterpriseData = res.data;
        }
      });
    },
    // 个人空间作品
    statistics_personal_design_data() {
      var data = {
        team_id: this.loginInfo.current_team_id,
        start_date: this.startTime,
        end_date: this.endTime,
      };
      Statistics.statistics_personal_design_data(data).then((res) => {
        if (res.status == 1) {
          this.personalData = res.data;
        }
      });
    },
    // 折线图
    statistics_active() {
      var data = {
        team_id: this.loginInfo.current_team_id,
        start_time: this.startTime,
        end_time: this.endTime,
        pagesize: this.page_size,
        page: this.page,
      };
      Statistics.statistics_member_detail_line(data).then((res) => {
        if (res.status == 1) {
          this.activeList = res.data.data;
          this.newArr = [];
          var arr = [];
          var tempArr = [];
          // this.min = this.activeList[0].active_account;
          // this.max = this.activeList[0].active_account;
          for (var i = 0, j = this.activeList && this.activeList.length; i < j; i++) {
            tempArr.push(
              this.activeList[i].date.split("-")[1] +
                "/" +
                this.activeList[i].date.split("-")[2],
              this.activeList[i].active_account
            );
            this.newArr.push(tempArr.slice(0));
            tempArr.length = 0;
            // arr.push(this.activeList[i].active_account)
          }
          // this.max=Math.max.apply(null, arr)//最大值
          // this.min=Math.min.apply(null, arr)//最小值
          this.drawLine();
        }
      });
    },
    /**
     * 列表
     */
    // 版权图片使用数据列表(1)
    statistics_use_list() {
      var data = {
        team_id: this.loginInfo.current_team_id,
        start_time: this.startTime,
        end_time: this.endTime,
      };
      Statistics.statistics_use_data(data).then((res) => {
        if (res.status == 1) {
          this.userList = res.data.data;
        }
      });
    },
    // 成员作品数据(2)
    statistics_design_data() {
      var data = {
        team_id: this.loginInfo.current_team_id,
        start_time: this.startTime,
        end_time: this.endTime,
      };
      Statistics.statistics_member_design_data(data).then((res) => {
        if (res.status == 1) {
          this.designData = res.data.data;
        }
      });
    },
    // 作品下载数据(3)
    statistics_enterprise_design_download_data() {
      var data = {
        team_id: this.loginInfo.current_team_id,
        start_time: this.startTime,
        end_time: this.endTime,
        page : 1,
        page_size : 10
      };
      Statistics.statistics_enterprise_design_download_data(data).then(
        (res) => {
          if (res.status == 1) {
            this.downloadData = res.data.data;
          }
        }
      );
    },
    /**
     * 更多列表
     */
    // 版权图片用量详情(1)
    statistics_use_num_details() {
      this.load = false;
      var data = {
        team_id: this.loginInfo.current_team_id,
        start_time: this.startTime,
        end_time: this.endTime,
        page_size: this.page_size,
        page: this.page,
      };
      Statistics.statistics_use_num_details(data).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 500);
        if (res.status == 1) {
          if (res.data.data && res.data.data.length > 0) {
            this.page++;
            res.data.data.forEach((res) => {
              this.list.push(res);
            });
            setTimeout(() => {
              this.load = true;
            }, 300);
          } else {
            this.aq = false;
            this.loadShow = true;
            setTimeout(() => {
              this.load = true;
            }, 300);
          }
        }
      });
    },
    // 版权图片使用数据详情(2)
    statistics_use_details() {
      this.load = false;
      var data = {
        team_id: this.loginInfo.current_team_id,
        start_time: this.startTime,
        end_time: this.endTime,
        page_size: this.page_size,
        page: this.page,
      };
      Statistics.statistics_use_data(data).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 500);
        if (res.status == 1) {
          if (res.data.data && res.data.data.length > 0) {
            this.page++;
            res.data.data.forEach((res) => {
              this.list.push(res);
            });
            setTimeout(() => {
              this.load = true;
            }, 300);
          } else {
            this.aq = false;
            this.loadShow = true;
            setTimeout(() => {
              this.load = true;
            }, 300);
          }
        }
      });
    },
    // 成员情况更多(3)
    statistics_detail_list() {
      this.load = false;
      var data = {
        team_id: this.loginInfo.current_team_id,
        start_time: this.startTime,
        end_time: this.endTime,
        pagesize: this.page_size,
        page: this.page,
      };
      Statistics.statistics_member_ship_data_list(data).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 500);
        if (res.status == 1) {
          if (res.data.data && res.data.data.length > 0) {
            this.page++;
            res.data.data.forEach((res) => {
              this.list.push(res);
            });
            setTimeout(() => {
              this.load = true;
            }, 300);
          } else {
            this.aq = false;
            this.loadShow = true;
            setTimeout(() => {
              this.load = true;
            }, 300);
          }
        }
      });
    },
    // 成员作品数据更多(4)
    statistics_design_data_list() {
      var data = {
        team_id: this.loginInfo.current_team_id,
        start_time: this.startTime,
        end_time: this.endTime,
        pagesize: this.page_size,
        page: this.Pagination.page,
      };
      Statistics.statistics_member_design_data(data).then((res) => {
        this.loading = false;
        if (res.status == 1) {
          this.Pagination.total = res.data.total;
          if (res.data.data && res.data.data.length > 0) {
            // this.page++
            // res.data.data.forEach(res => {
            //   this.list.push(res)
            // });

            this.list = res.data.data;
            setTimeout(() => {
              this.load = true;
            }, 300);
          } else {
            // this.aq = false
            this.loadShow = true;
            setTimeout(() => {
              this.load = true;
            }, 300);
          }
        }
      });
    },
    // 企业空间作品更多(5)
    statistics_enterprise_design_detail_list() {
      this.load = false;
      var data = {
        team_id: this.loginInfo.current_team_id,
        start_time: this.startTime,
        end_time: this.endTime,
        pagesize: this.page_size,
        page: this.page,
      };
      Statistics.statistics_team_design_total_details(data).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 500);
        if (res.status == 1) {
          if (res.data.data && res.data.data.length > 0) {
            this.page++;
            res.data.data.forEach((res) => {
              this.list.push(res);
            });
            setTimeout(() => {
              this.load = true;
            }, 300);
          } else {
            this.aq = false;
            this.loadShow = true;
            setTimeout(() => {
              this.load = true;
            }, 300);
          }
        }
      });
    },
    // 个人空间作品更多(6)
    statistics_personal_design_detail_list() {
      this.load = false;
      var data = {
        team_id: this.loginInfo.current_team_id,
        start_time: this.startTime,
        end_time: this.endTime,
        pagesize: this.page_size,
        page: this.page,
      };
      Statistics.statistics_team_design_total_details(data).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 500);
        if (res.status == 1) {
          if (res.data.data && res.data.data.length > 0) {
            this.page++;
            res.data.data.forEach((res) => {
              this.list.push(res);
            });
            setTimeout(() => {
              this.load = true;
            }, 300);
          } else {
            this.aq = false;
            this.loadShow = true;
            setTimeout(() => {
              this.load = true;
            }, 300);
          }
        }
      });
    },
    // 作品下载数据更多(7)
    statistics_enterprise_design_download_data_list() {
      this.load = false;
      var data = {
        team_id: this.loginInfo.current_team_id,
        start_time: this.startTime,
        end_time: this.endTime,
        pagesize: this.page_size,
        page: this.Pagination.page,
      };
      Statistics.statistics_enterprise_design_download_data(data).then(
        (res) => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
          if (res.status == 1) {
            this.Pagination.total = res.data.total;

            if (res.data.data && res.data.data.length > 0) {
              // this.page++
              // res.data.data.forEach(res => {
              //   this.list.push(res)
              // });
              this.list = res.data.data;
              setTimeout(() => {
                this.load = true;
              }, 300);
            } else {
              this.aq = false;
              this.loadShow = true;
              setTimeout(() => {
                this.load = true;
              }, 300);
            }
          }
        }
      );
    },
    // 成员活跃详情(8)
    statistics_active_details() {
      this.load = false;
      var data = {
        team_id: this.loginInfo.current_team_id,
        start_time: this.startTime,
        end_time: this.endTime,
        page_size: this.page_size,
        page: this.page,
      };
      Statistics.statistics_member_ship_data_list(data).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 500);
        if (res.status == 1) {
          if (res.data.data && res.data.data.length > 0) {
            this.page++;
            res.data.data.forEach((item) => {
              this.list.push(item);
            });
            setTimeout(() => {
              this.load = true;
            }, 300);
          } else {
            this.aq = false;
            this.loadShow = true;
            setTimeout(() => {
              this.load = true;
            }, 300);
          }
        }
      });
    },
    /**
     * 导出操作
     */
    // 版权图片用量详情导出(1)
    statistics_use_num_details_export() {
      var data = {
        team_id: this.loginInfo.current_team_id,
        start_time: this.startTime,
        end_time: this.endTime,
      };
      Statistics.statistics_use_num_details_export(data,{responseType: 'blob'}).then((res) => {
        this.downExcelData(
          res.data.url,
          "版权图片用量" + this.getLocalTime(res.data.time, 2)
        );
      });
    },
    // 版权图片使用数据详情导出(2)
    statistics_use_list_export() {
      var data = {
        team_id: this.loginInfo.current_team_id,
        start_time: this.startTime,
        end_time: this.endTime,
      };
      Statistics.statistics_use_data_export(data,{responseType: 'blob'}).then((res) => {
        this.downExcelData(
          res.data.url,
          "版权图片使用数据" + this.getLocalTime(res.data.time, 2)
        );
      });
    },
    // 成员情况导出(3)
    statistics_detail_export() {
      var data = {
        team_id: this.loginInfo.current_team_id,
        start_time: this.startTime,
        end_time: this.endTime,
      };
      Statistics.statistics_member_detail_export(data,{responseType: 'blob'}).then((res) => {
        this.downExcelData(
          res.data.url,
          "成员情况" + this.getLocalTime(res.data.time, 2)
        );
      });
    },
    // 成员情况导出(4)
    statistics_design_data_export() {
      var data = {
        team_id: this.loginInfo.current_team_id,
        start_time: this.startTime,
        end_time: this.endTime,
      };
      Statistics.statistics_member_design_data_export(data,{responseType: 'blob'}).then((res) => {
        this.downExcelData(
          res.data.url,
          "成员作品数据" + this.getLocalTime(res.data.time, 2)
        );
      });
    },
    // 企业空间作品导出(5)
    statistics_enterprise_design_detail_export() {
      var data = {
        team_id: this.loginInfo.current_team_id,
        start_time: this.startTime,
        end_time: this.endTime,
        type: 2
      };
      Statistics.statistics_team_design_total_export(data,{responseType: 'blob'}).then(
        (res) => {
          this.downExcelData(
            res.data.url,
            "企业空间作品" + this.getLocalTime(res.data.time, 2)
          );
        }
      );
    },
    // 个人空间作品导出(6)
    statistics_personal_design_download_data_export() {
      var data = {
        team_id: this.loginInfo.current_team_id,
        start_time: this.startTime,
        end_time: this.endTime,
        type: 1
      };
      Statistics.statistics_team_design_total_export(data,{responseType: 'blob'}).then(
        (res) => {
          this.downExcelData(
            res.data.url,
            "个人空间作品" + this.getLocalTime(res.data.time, 2)
          );
        }
      );
    },
    // 作品下载数据导出(7)
    statistics_enterprise_design_download_data_export() {
      var data = {
        team_id: this.loginInfo.current_team_id,
        start_time: this.startTime,
        end_time: this.endTime,
      };
      Statistics.statistics_enterprise_design_download_data_export(data, {responseType: 'blob'}).then(
        (res) => {
          this.downExcelData(
            res.data.url,
            "作品下载数据" + this.getLocalTime(res.data.time, 2)
          );
        }
      );
    },
    // 成员活跃详情导出(8)
    statistics_active_details_export() {
      var data = {
        team_id: this.loginInfo.current_team_id,
        start_time: this.startTime,
        end_time: this.endTime,
      };
      Statistics.statistics_member_active_export(data, {responseType: 'blob'}).then((res) => {
        this.downExcelData(
          res.data.url,
          "活跃账号数-明细" + this.getLocalTime(res.data.time, 2)
        );
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.statisticstop {
  margin-right: 20px;
  height: 60px;
  background: #f7f6f9;
  border-radius: 4px;
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.allimg {
  ::v-deep( .el-popover__reference) {
    margin-right: 6px;
  }
}

.topTitle {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #3b3946;
  display: flex;

  li {
    margin-left: 30px;
    cursor: pointer;
  }

  .active {
    color: #6035f5;
  }
}

.statistics {
  ::v-deep( .el-button--small) {
    padding: 0;
  }

  ::v-deep( .el-date-editor) {
    width: 240px;
  }

  ::v-deep( .el-input__icon) {
    display: none;
  }

  ::v-deep( .el-dialog .el-dialog__body) {
    padding: 0 24px;
  }

  ::v-deep( .el-button) {
    width: 68px;
    height: 28px;
    // border-color: #5a2df5;
    // color: #5a2df5;
  }

  ::v-deep( .el-table::before) {
    height: 0;
  }

  .export {
    cursor: pointer;
    width: 108px;
    height: 36px;
    padding: 0;
    color: #fff;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    margin-left: auto;
    margin-right: 20px;

    &:hover {
      color: #fff;
      border-color: #431cc9;
      background-color: #431cc9;
    }
  }

  ::v-deep( .iconfont) {
    margin-right: 4px;
  }

  ::v-deep( .el-table thead) {
    color: #3b3946;
    font-weight: 500;
  }

  min-height: calc(100vh - 60px);

  .mi-left {
    color: #3c3c43;

    .mil-title {
      display: flex;

      img {
        width: 40px;
        height: 40px;
        margin-left: 30px;
        cursor: pointer;
      }
    }

    .team-upgrade {
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #7966fe;
      margin-left: 100px;
    }

    h3 {
      font-size: 25px;
      line-height: 36px;
      max-width: 350px;
    }

    p {
      margin-top: 8px;
      line-height: 20px;
      font-size: 14px;
    }
  }

  .mc-title {
    width: calc(50% - 20px);
    min-height: 866px;
    background: #f7f6f9;
    border-radius: 4px;
    padding: 20px;
    margin-right: 20px;
    margin-bottom: 20px;

    h4 {
      color: #2d2d32;
      line-height: 20px;
      font-size: 18px;
    }
  }

  .mc-con {
    height: 590px;
    margin-top: 23px;
    background: #ffffff;
    border-radius: 4px;
  }

  ::v-deep( .el-table) {
    width: auto;
    color: #3b3946;
  }

  ::v-deep( .is-leaf) {
    border: none;
  }

  ::v-deep( .el-table__header-wrapper) {
    border-radius: 4px;
    // height: 48px;
  }

  ::v-deep( .el-table td) {
    padding: 5px 0;
  }
  ::v-deep( .el-table tr) {
    height: 47px !important;
  }

  ::v-deep( .el-table th) {
    padding: 0;
    // height: 48px;
  }
}

.mctitle {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3b3946;
  background: #ffffff;
  border-radius: 4px;
}

.mc_top {
  margin: 0 24px;
  margin-top: 16px;
  display: flex;
  align-items: center;
  height: 54px;
  border-bottom: 1px solid #f0eef3;

  .left {
    display: flex;
    align-items: center;
  }

  .p1 {
    width: 4px;
    height: 16px;
    background: #5a2df5;
    border-radius: 1px;
    margin-right: 8px;
  }

  .p2 {
    color: #3b3946;
  }

  .rightbtn {
    display: flex;
    margin-left: auto;

    ul {
      cursor: pointer;
      width: 68px;
      height: 28px;
      background: rgba(255, 255, 255, 0);
      border-radius: 4px;
      border: 1px solid #5a2df5;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #5a2df5;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 14px;

      img {
        width: 16px;
        height: 16px;
      }
    }
  }
}

.mc_bottom {
  margin: 0 24px;
  padding-bottom: 24px;

  .mc_progress {
    display: flex;
  }

  .mc_ul {
    width: 346px;
    display: flex;
  }

  .li1 {
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3b3946;
    line-height: 42px;
  }

  .li2 {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #8a888f;
    line-height: 17px;
  }
}

.popimg {
  width: 500px;
  height: 500px;
  background: #f7f6f9;
  box-shadow: 0px 10px 30px 6px rgba(0, 0, 0, 0.1);
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.timeTip {
  width: 644px;
  height: 39px;
  line-height: 39px;
  position: absolute;
  top: 33px;
  background: #ffffff;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  box-shadow: 0px 0px 5px 0px #ebeef5;
  border-bottom: 1px solid #ebeef5;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  margin-left: 1px;
  z-index: 9999;
  padding-left: 10px;
}

.chartLine {
  position: absolute;
  background: #fff;
  z-index: 1;
  display: flex;
  align-items: center;
  right: 51px;
  top: 166px;
}

.chartLinep {
  width: 12px;
  height: 4px;
  background: #5a2df5;
  border-radius: 2px;
  margin-right: 8px;
}

.mt {
  margin-top: 11px;
}

.imgcon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
<style lang="scss">
.popover {
  padding: 0;
  background: none;

  .popper__arrow {
    display: none;
  }
}

.el-date-table td.end-date span,
.el-date-table td.start-date span {
  border-radius: 2px;
}

.el-date-table td.end-date div {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}

.el-date-table td.start-date div {
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.el-date-range-picker__content {
  padding: 0;
}

.el-date-range-picker__content.is-left {
  border: none;
}

.el-date-range-picker__header {
  height: auto;
  border-bottom: solid 1px #ebeef5;
  padding: 4px 9px;
}

.el-date-table th {
  font-size: 14px;
  color: #000000;
}

.el-date-range-picker__header div {
  font-size: 14px;
  color: #000000;
}

.el-popper .popper__arrow {
  display: none;
}

.el-picker-panel {
  margin: 0;
}

.el-date-range-picker {
  // box-shadow: none;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  margin-top: 40px !important;
}
</style>
